import { RaaDialog } from 'raa-react';

import { BebyggelseobjektUtkastIndex } from 'models';

import { useDialog } from './useDialog';

export const useLockedUtkastDialog = () => {
  const { setDialog, unsetDialog } = useDialog();

  const openLockedUtkastDialog = (utkast: BebyggelseobjektUtkastIndex) => {
    setDialog(RaaDialog, {
      header: 'Utkastet är låst',
      close: unsetDialog,
      cancelButtonText: 'stäng',
      cancel: unsetDialog,
      ariaDescribedBy: 'dialog-description',
      children: (
        <p id="dialog-description" className="tw-mt-8">
          Utkastet redigeras av {utkast.registrering.reservation.reserverad_av_anvandarnamn} och kan inte ändras av
          någon annan.
        </p>
      )
    });
  };

  return { openLockedUtkastDialog };
};
